import { Entity } from "../../data/models.interface"
import useLazyQuery from "../useLazyQuery"

export const useSaveEntityQuery = (entityId = "error") => {
	const url =
		entityId === "new"
			? `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/entities`
			: `${process.env.REACT_APP_ACCESS_CONTROL_BACK_URL}/entities/${entityId}`
	const method = entityId === "new" ? "POST" : "PATCH"
	return useLazyQuery<Entity, void>(url, method)
}
